import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { Shift } from '@/openapi';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useCreateShiftMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (shift: Shift) => {
      return ScheduleConfigService.scheduleConfigServiceCreateShift({
        body: shift,
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.shifts.list() }),
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.withShifts(),
        }),
      ]);
    },
  });
};
